import React from "react";
import "../../../styles/payrole-system/payrole-processor.css";
import {
  formatStatsValue,
  getMetricId,
  getStatsLabel,
  getStatsSubLabel,
  getStatsTextColor,
} from "../PayroleMocks";

const BulkSummaryCards = ({ statsData = {}, classname, isHistory = false }) => {
  return (
    <div className="pp-bulk-summary-cards mt30">
      {Object.entries(statsData).map(([key, value]) => (
        <div
          key={key}
          className={`pp-bulk-summary-card ${classname || ""} pp-${key || ""}`}
        >
          <div className="pp-bulk-card-label">{getStatsLabel(key)}</div>

          <div
            className={`pp-bulk-card-value ${getMetricId(key)}`}
            style={{ color: getStatsTextColor(key) }}
          >
            {formatStatsValue(key, value)}
          </div>

          <div className="pp-bulk-card-subtitle">{getStatsSubLabel(key, isHistory)}</div>
        </div>
      ))}
    </div>
  );
};

export default BulkSummaryCards;
